import { render, staticRenderFns } from "./order_underline.vue?vue&type=template&id=8d601cd4&scoped=true"
import script from "./order_underline.vue?vue&type=script&lang=js"
export * from "./order_underline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d601cd4",
  null
  
)

export default component.exports